<template>
    <div class="validate-address-dialog py-3">
        <div>
            <h4 class="mb-0 h4 px-3">Address Validation</h4> <div class="me-2 ai-essential-address-btn">
        </div>
            <hr />
        </div>
        <div class="px-3 py-2">
            <div v-if="validAddress">
                <p>
                    The patient's primary address will be used for documentation, claims and verifying location on a
                    mobile device. Suggested changes are marked in
                    <span class="text-danger">red</span>.
                </p>
                <div class="row g-0">
                    <div class="col-12 col-sm-6 pe-sm-2 d-flex border-bottom">
                        <div>
                            <div class="card-body">
                                <h5 class="card-title">Primary Address</h5>
                                <div class="card-text">
                                    <address>
                                        {{ options.originalAddress.addressLine1 }}
                                        <p class="m-0"
                                           v-if="options.originalAddress.addressLine2?.length > 0">
                                            {{ options.originalAddress.addressLine2 }}</p>
                                        <p class="m-0"> {{ options.originalAddress.city }}</p>
                                        <p class="m-0"> {{ options.originalAddress.state }} {{
                                            options.originalAddress.zipCode
                                            ? "," : "" }} {{ formatZipCode(options.originalAddress.zipCode) }}</p>
                                        <p class="m-0"> {{ options.originalAddress.county }}</p>
                                        <p class="m-0"> {{ originalAddressCountry }}</p>
                                    </address>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-12 col-sm-6 d-flex border-bottom">
                        <div>
                            <div class="card-body axxess-intelligence-border">
                                <h5 class="card-title">Validated Primary Address</h5>
                                <div class="card-text">
                                    <address>
                                        <p
                                           :class="`m-0 ${checkEqualAddress(options.originalAddress.addressLine1, options.updatedAddress.addressLine1)}`">
                                            {{ options.updatedAddress.addressLine1 }}
                                        </p>
                                        <p
                                           :class="`m-0 ${checkEqualAddress(options.originalAddress.addressLine2, options.updatedAddress.addressLine2)}`">
                                            {{ options.updatedAddress.addressLine2 }}
                                        </p>
                                        <p
                                           :class="`m-0 ${checkEqualAddress(options.originalAddress.city, options.updatedAddress.city)}`">
                                            {{ options.updatedAddress.city }}
                                        </p>
                                        <p
                                           :class="`m-0 ${checkEqualAddress(options.originalAddress.state, options.updatedAddress.state)} 
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               ${checkEqualAddress(options.originalAddress.zipCode, options.updatedAddress.zipCode)}`">
                                            {{ options.updatedAddress.state }} {{ options.updatedAddress.zipCode ? "," : ""
                                            }}
                                            {{ formatZipCode(options.updatedAddress.zipCode) }}
                                        </p>
                                        <p
                                           :class="`m-0 ${checkEqualAddress(options.originalAddress.county, options.updatedAddress.county)}`">
                                            {{ options.updatedAddress.county }}
                                        </p>
                                        <p
                                           class="`m-0 {originalAddressCountry && updatedAddressCountry && originalAddressCountry === updatedAddressCountry ? '' : 'text-danger'}`">
                                            {{ updatedAddressCountry }}
                                        </p>
                                    </address>
                                </div>
                            </div>
                        </div>
                        <div class="form-check pt-4 mt-4 ps-4 ms-4">
                            <label class="form-check-label">
                                <input class="form-check-input au-target"
                                       type="checkbox"
                                       v-model="options.updatedAddress.primaryUpdate">
                                Update Primary
                            </label>
                        </div>
                    </div>
                    <div class="col-12 d-flex"
                         v-if="validVisitAddress === true">
                        <div class="col-12 col-sm-6 pe-sm-2 ps-0 d-flex border-bottom">
                            <div>
                                <div class="card-body">
                                    <h5 class="card-title">Visiting Address</h5>
                                    <div class="card-text">
                                        <address>
                                            {{ options.originalAddress.visitAddressLine1 }}
                                            <p class="m-0"
                                               v-if="options.originalAddress.visitAddressLine2?.length > 0">
                                                {{ options.originalAddress.visitAddressLine2 }}</p>
                                            <p class="m-0"> {{ options.originalAddress.visitCity }}</p>
                                            <p class="m-0"> {{ options.originalAddress.visitState }}
                                                {{ options.originalAddress.visitZipCode ? "," : "" }}
                                                {{ formatZipCode(options.originalAddress.visitZipCode) }}</p>
                                            <p class="m-0"> {{ options.originalAddress.visitCounty }}</p>
                                            <p class="m-0"> {{ originalAddressCountry }}</p>
                                        </address>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-12 col-sm-6 px-0 d-flex border-bottom">
                            <div>
                                <div class="card-body me-1">
                                    <h5 class="card-title">Validated Visiting Address</h5>
                                    <div class="card-text">
                                        <address>
                                            <p
                                               :class="`m-0 ${checkEqualAddress(options.originalAddress.visitAddressLine1, options.updatedAddress.visitAddressLine1)}`">
                                                {{ options.updatedAddress.visitAddressLine1 }}
                                            </p>
                                            <p v-if="options.updatedAddress.visitAddressLine2?.length > 0"
                                               :class="`m-0 ${checkEqualAddress(options.originalAddress.visitAddressLine2, options.updatedAddress.visitAddressLine2)}`">
                                                {{ options.updatedAddress.visitAddressLine2 }}
                                            </p>
                                            <p
                                               :class="`m-0 ${checkEqualAddress(options.originalAddress.visitCity, options.updatedAddress.visitCity)}`">
                                                {{ options.updatedAddress.visitCity }}
                                            </p>
                                            <p
                                               :class="`m-0 ${checkEqualAddress(options.originalAddress.visitState, options.updatedAddress.visitState)}
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ${checkEqualAddress(options.originalAddress.visitZipCode, options.updatedAddress.visitZipCode)}`">
                                                {{ options.updatedAddress.visitState }} {{
                                                    options.updatedAddress.visitZipCode
                                                    ? "," : "" }}
                                                {{ formatZipCode(options.updatedAddress.visitZipCode) }}
                                            </p>
                                            <p
                                               :class="`m-0 ${checkEqualAddress(options.originalAddress.visitCounty, options.updatedAddress.visitCounty)}`">
                                                {{ options.updatedAddress.visitCounty }}
                                            </p>
                                            <p
                                               :class="`m-0 ${originalAddressCountry && updatedAddressCountry && originalAddressCountry === updatedAddressCountry ? '' : 'text-danger'}`">
                                                {{ updatedAddressCountry }}
                                            </p>
                                        </address>
                                    </div>
                                </div>
                            </div>
                            <div class="form-check pt-4 mt-4 ps-4 ms-4">
                                <label class="form-check-label">
                                    <input class="form-check-input au-target"
                                           type="checkbox"
                                           v-model="options.updatedAddress.visitUpdate">
                                    Update Visit
                                </label>
                            </div>
                        </div>
                    </div>
                    <div class="col-12 col-sm-6 pe-sm-2 d-flex border-bottom">
                        <div>
                            <div class="card-body">
                                <h5 class="card-title">Mailing Address</h5>
                                <div class="card-text">
                                    <address>
                                        {{ options.originalAddress.mailingAddressLine1 }}
                                        <p class="m-0"
                                           v-if="options.originalAddress.mailingAddressLine2?.length > 0">
                                            {{ options.originalAddress.mailingAddressLine2 }}</p>
                                        <p class="m-0"> {{ options.originalAddress.mailingCity }}</p>
                                        <p class="m-0"> {{ options.originalAddress.mailingState }}
                                            {{ options.originalAddress.mailingZipCode ? "," : "" }}
                                            {{ formatZipCode(options.originalAddress.mailingZipCode) }}</p>
                                        <p class="m-0"> {{ options.originalAddress.mailingCounty }}</p>
                                        <p class="m-0"> {{ originalAddressCountry }}</p>
                                    </address>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-12 col-sm-6 d-flex border-bottom">
                        <div>
                            <div class="card-body">
                                <h5 class="card-title">Validated Mailing Address</h5>
                                <p class="card-text">
                                <address>
                                    <p
                                       :class="`m-0 ${checkEqualAddress(options.originalAddress.mailingAddressLine1, options.updatedAddress.mailingAddressLine1)}`">
                                        {{ options.updatedAddress.mailingAddressLine1 }}
                                    </p>
                                    <p v-if="options.updatedAddress.mailingAddressLine2?.length > 0"
                                       :class="`m-0 ${checkEqualAddress(options.originalAddress.mailingAddressLine2, options.updatedAddress.mailingAddressLine2)}`">
                                        {{ options.updatedAddress.mailingAddressLine2 }}
                                    </p>
                                    <p
                                       :class="`m-0 ${checkEqualAddress(options.originalAddress.mailingCity, options.updatedAddress.mailingCity)}`">
                                        {{ options.updatedAddress.mailingCity }}
                                    </p>
                                    <p
                                       :class="`m-0 ${checkEqualAddress(options.originalAddress.mailingState, options.updatedAddress.mailingState)} 
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                              ${checkEqualAddress(options.originalAddress.mailingZipCode, options.updatedAddress.mailingZipCode)}`">
                                        {{ options.updatedAddress.mailingState }} {{ options.updatedAddress.mailingZipCode ?
                                            "," : "" }}
                                        {{ formatZipCode(options.updatedAddress.mailingZipCode) }}
                                    </p>
                                    <p
                                       :class="`m-0 ${checkEqualAddress(options.originalAddress.mailingCounty, options.updatedAddress.mailingCounty)}`">
                                        {{ options.updatedAddress.mailingCounty }}
                                    </p>
                                    <p
                                       :class="`m-0 {originalAddressCountry && updatedAddressCountry && originalAddressCountry === updatedAddressCountry ? '' : 'text-danger'}`">
                                        {{ updatedAddressCountry }}
                                    </p>
                                </address>
                                </p>
                            </div>
                        </div>
                        <div class="form-check pt-4 mt-4 ps-4 ms-4">
                            <label class="form-check-label">
                                <input class="form-check-input au-target"
                                       type="checkbox"
                                       v-model="options.updatedAddress.mailingUpdate">
                                Update Mailing
                            </label>
                        </div>
                    </div>
                </div>
            </div>
            <div v-if="!validAddress">
                <p>Please enter Address to Validate.</p>
            </div>
        </div>
        <hr />
        <div class="d-flex justify-content-end px-3">
            <button type="button"
                    class="btn btn-light border border-secondary me-1"
                    @click="cancel()">
                {{ validAddress ? "Keep Current Address" : "Cancel" }}
            </button>
            <button type="button"
                    class="btn btn-primary border border-primary"
                    @click="ok()"
                    v-if="validAddress">
                Use Validated Address
            </button>
        </div>
    </div>
</template>

<style src="./ValidateAddressHomeHealth.scss"></style>
<script lang="ts" src="./ValidateAddressHomeHealth.ts"></script>